import React from "react";
import ProductCard from "./components/ProductCard";
import WelcomePlaceholder from "./components/WelcomePlaceholder";
import { Productbtn } from "../../../../../shared/services/interfacev2";

interface ProductGridProps {
  products: Productbtn[];
  categorySelected: boolean;
  onProductSelect: (product: Productbtn) => void;
  selectedProduct?: string | null;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  categorySelected,
  onProductSelect,
  selectedProduct,
}) => {
  if (!categorySelected) return <WelcomePlaceholder />;

  return (
    // Added h-full overflow-y-auto thin-scrollbar
    <div className="w-[95%] h-full mx-auto p-0.5 flex flex-col justify-between overflow-y-auto thin-scrollbar" id="product-grid">
      <div className="grid grid-cols-[repeat(auto-fill,minmax(165px,1fr))] gap-4 p-2 w-full">
        {Array.isArray(products) &&
          products.map((product) => (
            <ProductCard
              key={product._id.$oid}
              product={product}
              onSelect={onProductSelect}
              isSelected={selectedProduct === product._id.$oid}
            />
          ))}

        {products.length < 1 && (
          <p className="col-span-full text-center text-gray-500">
            Product not available. Please go to Settings → Product tab and add the product.
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductGrid;